import { path } from 'ramda';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AUTH_REDUCER } from 'js/store/constants';
import { usePrevious } from 'js/hooks/usePrevious';

export const useCloseOnLogout = (onClose) => {
    const isLogoutInProcess = useSelector(path([AUTH_REDUCER, 'isLogoutInProcess']));
    const prevIsLogoutInProcess = usePrevious(isLogoutInProcess);

    useEffect(() => {
        if (prevIsLogoutInProcess) {
            onClose();
        }

    }, [prevIsLogoutInProcess, onClose]);
};
